// @ts-nocheck
import React from "react";
import hiraLogo from "../assets/images/hira-logo.jpeg";
import { useLanguageContext } from "../context/languageContext";

/**
 * Welcome banner.
 *
 * The logo's own green with a sand accent, and the logo given a plate of its own
 * so it reads as a mark rather than as decoration. The artwork is a wide,
 * white-background JPEG, so unlike a white logo it needs the plate to be white
 * too - dropped straight onto the green it would show as a pale rectangle.
 *
 * `tableId` comes from the QR code on the table, and is simply left out when the
 * page was opened without one.
 */
export const WelcomeBanner = ({ tableId }) => {
    const { t } = useLanguageContext();

    return (
        <section className="px-4 pt-4 pb-1 animate-app-reveal text-sharp">
            <div className="relative overflow-hidden rounded-[1.25rem] bg-forest shadow-[0_10px_30px_-16px_rgba(0,77,38,0.9)]">
                {/* Depth, kept subtle so the logo stays the brightest thing here */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-20 -right-16 w-56 h-56 rounded-full bg-forest-light opacity-60 blur-[70px]"></div>
                    <div
                        className="absolute inset-0 opacity-[0.05]"
                        style={{ backgroundImage: "radial-gradient(circle, white 1px, transparent 0)", backgroundSize: "18px 18px" }}
                    ></div>
                </div>

                <div className="relative z-10 flex items-center gap-4 px-5 py-5">
                    <div className="flex-shrink-0 w-[86px] h-[64px] rounded-2xl bg-white ring-1 ring-white/15 flex items-center justify-center p-2">
                        <img
                            src={hiraLogo}
                            alt="Piceri Hira"
                            className="max-w-full max-h-full object-contain"
                        />
                    </div>

                    <div className="min-w-0 flex-1 space-y-1">
                        <p className="text-[8px] font-black uppercase tracking-[0.22em] text-sand">
                            Bar Restorant &amp; Piceri
                        </p>
                        <h1 className="text-[17px] sm:text-xl font-clash text-white tracking-tight leading-tight truncate">
                            {t("welcome_banner")}
                        </h1>
                        <p className="text-white/45 text-[10px] font-medium leading-snug line-clamp-2">
                            {t("glad_message")}
                        </p>
                    </div>
                </div>

                {tableId && (
                    <div className="relative z-10 flex items-center justify-between gap-3 px-5 py-2.5 bg-white/[0.06] border-t border-white/10">
                        <span className="text-[9px] font-black uppercase tracking-[0.2em] text-white/50">
                            {t("welcome_banner")}
                        </span>
                        <span className="flex-shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-sand text-forest text-[9px] font-black uppercase tracking-wider">
                            {t("tableNo")} {tableId}
                        </span>
                    </div>
                )}
            </div>
        </section>
    );
};
